<template>
    <div class='container-fluid padding-0' style="margin-top: -15px">
        <div class="row">
            <div class="col-md-12">
                <slot> </slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "general-error",
    }
</script>

<style scoped>

</style>